import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const TeamsOnboardingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new channel onboarding page
    navigate('/integration/teams/channel-onboarding', { replace: true });
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4" />
        <p className="text-gray-600">Redirecting to channel onboarding...</p>
      </div>
    </div>
  );
};

export default TeamsOnboardingPage;